import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import { Paper } from "@mui/material";
import { fetchExpertRank, getTotalQuestionCount } from "../../../../API/api";
import styles from "./ExpertOverview.module.css";
import { Spin, Table, Typography } from "antd";
import TitleValue from "../seeker/TitleValue";
import PieChartComponent from "../../../GraphComponent/PieChartComponent";
import VizHeader from "../../../VizHeader/VizHeader";
import { useSelector } from "react-redux";
function convertMinutesToTime(minutes) {
  if (minutes == 0 || minutes === null) return "0 m";
  else {
    // parseInt(state.totalCountData[data])/60
    let hours = Math.floor(minutes / 60);
    let remainingMinutes = minutes % 60;
    let value = `${hours !== 0 ? `${hours}h` : ""}  ${
      remainingMinutes !== 0 ? `${Math.round(remainingMinutes)}m` : ""
    }`;
    if (value == NaN) return "0m";
    else return value;
  }
}
const columnsData = [
  {
    title: TitleValue("#"),
    dataIndex: "idVal",
    // width: "30%",
    align: "center",
    render: (_, raw) => (
      <>
        <span style={{ fontSize: "13px",
            color: "#2A364A",
            fontWeight: "500", }}>{raw.idVal}</span>
      </>
    ),
  },
  {
    title: TitleValue("Name"),
    dataIndex: "Name",
    align: "left",
    render: (_, raw) => (
      <>
        <span style={{  fontSize: "13px",
            color: "#2A364A",
            fontWeight: "500",}}>
          {/* <CountUp end={raw.seeker} /> */}
          {raw.Name}
        </span>
      </>
    ),
  },
  {
    title: TitleValue("Score"),
    dataIndex: "Score",
    align: "center",
    render: (_, raw) => (
      <>
        <span
          style={{
            fontSize: "13px",
            color: "#2A364A",
            fontWeight: "500",
            display: "flex",
            width: "60%",
            justifyContent: "flex-end",
            textAlign: "right",
          }}
        >
          {raw.Score}
        </span>
      </>
    ),
  },
  {
    title: TitleValue("Response Time"),
    dataIndex: "ResponseTime",
    align: "center",
    render: (_, raw) => (
      <>
        <span
          style={{
            fontSize: "13px",
            color: "#2A364A",
            fontWeight: "500",
            display: "flex",
            width: "50%",
            justifyContent: "flex-end",
            textAlign: "right",
          }}
        >
          {/* <CountUp end={raw.RatingCNT} duration={3.75} /> */}
          {/* <CountUp
            end={raw.ResponseTime}
            decimals={2}
            decimal="."
            duration={3.75}
          /> */}
          {raw.ResponseTime}
        </span>
      </>
    ),
  },
];
function ExpertRankTable({ setLoading }) {
  const [data, setData] = React.useState(null);
  const [averageTime, setAverageTime] = React.useState(null);
  const selectUser = useSelector((state) => state.seekerType);
  const { geoLevelId, geoLevelValue, domainId, length, check } = useSelector(
    (state) => {
      return {
        geoLevelId: state.cmRoot.selecetdRoutingValue,
        geoLevelValue: state.cmRoot?.selectedGeoLevel?.name,
        domainId: state.cmRoot?.selectedDomainIds,
        length: state.cmRoot?.selectedDomainsObj?.length,
        check: state.cmRoot.selecetdRoutingValue,
      };
    }
  );
  const state = useSelector((state) => state);
  React.useEffect(() => {
    setLoading(true);
    fetchExpertRank().then((res) => {
      if (res===undefined) return;
      setLoading(false);
      if (res.status === 200) {
        setData(res?.data);
      }
    });
    if (check !== "") {
      getTotalQuestionCount(
        state.cmRoot.selecetdRoutingValue,
        state.cmRoot.selectedGeoLevel.length === 0
          ? ""
          : state.cmRoot.selectedGeoLevel.label,
        state.cmRoot.selectedDomainIds,
        selectUser.userType.value !== null ? selectUser.userType.value : ""
      ).then((res) => {
        if (res===undefined) return;
        setLoading(false);
        if (res.data.success === true) {
          setAverageTime(res?.data?.data?.expertAvgRespTime);
        }
      });
    }
  }, [
    setLoading,
    geoLevelId,
    geoLevelValue,
    domainId,
    length,
    selectUser.userType.value,
    state.cmRoot.selecetdRoutingValue,
    state.cmRoot.selectedGeoLevel.length,
    state.cmRoot.selectedGeoLevel.label,
    state.cmRoot.selectedDomainIds,
    check,
  ]);
  const rows =
    data?.data?.expertScores &&
    data?.data?.expertScores?.map((item, index) => ({
      id: index,
      idVal: index + 1,
      Name: `${item.user?.firstName} ${item.user?.lastName}`,
      Score: item.score,
      ResponseTime: convertMinutesToTime(
        item?.expertAvgResponseTime?.avgRespTime
      ),
      time: item?.expertAvgResponseTime?.avgRespTime,
    }));
  const FooterComponent = () => {
    return (
      <>
        <div className={styles.footerParent}>
          <i
            class="fa fa-clock-o"
            aria-hidden="true"
            style={{ color: "#fff", fontSize: "18px" }}
          />
          {rows !== undefined && (
            <span style={{ display: "flex", alignItems: "center" }}>
              <Typography
                style={{
                  fontSize: "14px",
                  color: "#fff",
                  paddingLeft: "12px",
                  // weight: "bold",
                  fontWeight: "700",
                }}
              >
                Avg. Response:
              </Typography>
              <Typography
                style={{
                  fontSize: "20px",
                  color: "#fff",
                  paddingLeft: "5px",
                  fontWeight: "500",
                }}
              >
                {" "}
                {averageTime !== null
                  ? convertMinutesToTime(averageTime)
                  : "0 m"}
              </Typography>
            </span>
          )}
        </div>
      </>
    );
  };
  return (
    <>
      <div
        style={{
          width: "100%",
          marginTop: "8px",
          height: "356px",
          overflowY: "scroll",
        }}
      >
        <Table
                  rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' :  'table-row-dark'}

          showSorterTooltip={false}
          columns={columnsData}
          dataSource={rows}
          className={styles.table_component}
          pagination={false}
        />
      </div>
      <FooterComponent />
    </>
  );
}
function ExpertRank() {
  const [loading, setLoading] = useState(false);
  return (
    <div className={styles.ExpertOutline}>
      <Grid container spacing={2} xs={12}>
        <Grid item lg={7} sm={12} xs={12} md={12} xl={7}>
            <Paper>
              <PieChartComponent />
            </Paper>
        </Grid>
        <Grid item lg={5} sm={12} xs={12} md={12} xl={5}>
          <Spin spinning={loading}>
            {" "}
            <Paper sx={{ height: "460px" }}>
              <div
                style={{
                  textAlign: "center",
                  paddingTop: "10px",
                  overflow: "auto",
                }}
              >
                <span>
                  <VizHeader type={4} isBold={true}>
                    {" "}
                    Expert Ranks
                  </VizHeader>
                </span>
              </div>
              <ExpertRankTable setLoading={setLoading} />
            </Paper>
          </Spin>
        </Grid>
      </Grid>
    </div>
  );
}

export default ExpertRank;
